import { RouteObject } from 'react-router'

import { adminRoutes } from '@/router/StreamingPaths/admin.routes'
import { contentRoutes } from '@/router/StreamingPaths/content.routes'
import { dashboardRoutes } from '@/router/StreamingPaths/dashboard.routes'
import { eventRoutes } from '@/router/StreamingPaths/event.routes'
import { historicalStatistics } from '@/router/StreamingPaths/historicalStatistics.routes'
import { operatorRoutes } from '@/router/StreamingPaths/operators.dge.routes'
import { userRoutes } from '@/router/StreamingPaths/users.routes'

export const streamingPaths: RouteObject[] = [
  ...dashboardRoutes,
  ...contentRoutes,
  ...operatorRoutes,
  ...userRoutes,
  ...historicalStatistics,
  ...adminRoutes,
  ...eventRoutes
]
